// Creator Status Options — using design system tokens for theme adaptability
export const CREATOR_STATUS_OPTIONS = [
  { value: 'NeedsToSet', label: 'Needs to Set', color: 'bg-surface-3 text-text-secondary' },
  { value: 'In Reviewing', label: 'In Reviewing', color: 'bg-warning-muted text-warning' },
  { value: 'BrikctoRecruit', label: 'BrikctoRecruit', color: 'bg-surface-3 text-text-secondary' },
  { value: 'Pre-Approved', label: 'Pre-Approved', color: 'bg-info-muted text-info' },
  { value: 'High-Priority', label: 'High Priority', color: 'bg-success-muted text-success' },
  { value: 'Approved', label: 'Approved (Low Priority)', color: 'bg-warning-muted text-warning' },
  { value: 'Strong Enough', label: 'Strong Enough', color: 'bg-success-muted text-success' },
  { value: 'Strong Enough If We Need a Lot', label: 'Strong Enough If We Need a Lot', color: 'bg-info-muted text-info' },
  { value: 'Not Strong Enough', label: 'Not Strong Enough', color: 'bg-error-muted text-error' },
  { value: 'Last-Resort', label: 'Last Resort', color: 'bg-warning-muted text-warning' },
  { value: 'High Priority', label: 'High Priority', color: 'bg-success-muted text-success' },
  { value: '(Persona) High Priority', label: '(Persona) High Priority', color: 'bg-accent-muted text-accent' },
  { value: 'Low Priority', label: 'Low Priority', color: 'bg-warning-muted text-warning' },
  { value: 'Persona Low Priority', label: 'Persona Low Priority', color: 'bg-warning-muted text-warning' },
  { value: 'Persona Team 2', label: 'Persona Team 2', color: 'bg-accent-muted text-accent' },
  { value: 'Persona Team 1', label: 'Persona Team 1', color: 'bg-info-muted text-info' },
  { value: 'Persona: Team 3', label: 'Persona: Team 3', color: 'bg-error-muted text-error' },
  { value: 'Not Set', label: 'Not Set', color: 'bg-surface-3 text-text-secondary' },
  { value: 'active', label: 'Active (legacy)', color: 'bg-surface-3 text-text-secondary' }
];

// Creator Type Options for Web3/AI classification
export const CREATOR_TYPE_OPTIONS = [
  { value: 'web3', label: 'Web3', color: 'bg-info-muted text-info' },
  { value: 'ai', label: 'AI', color: 'bg-accent-muted text-accent' },
];

export const getCreatorTypeLabel = (type) => {
  const option = CREATOR_TYPE_OPTIONS.find(o => o.value === type);
  return option ? option.label : type;
};

export const getCreatorTypeColor = (type) => {
  const option = CREATOR_TYPE_OPTIONS.find(o => o.value === type);
  return option ? option.color : 'bg-surface-3 text-text-secondary';
};

// Campaign-specific Status Options
export const CAMPAIGN_STATUS_OPTIONS = {
  briefing: [
    { value: 'not_started', label: 'Not Started', color: 'bg-surface-3 text-text-secondary' },
    { value: 'briefing_sent', label: 'Briefing Sent', color: 'bg-info-muted text-info' },
    { value: 'briefing_accepted', label: 'Briefing Accepted', color: 'bg-success-muted text-success' },
    { value: 'briefing_rejected', label: 'Briefing Rejected', color: 'bg-error-muted text-error' }
  ],
  delivery: [
    { value: 'WAITING', label: 'Waiting', color: 'bg-surface-3 text-text-secondary' },
    { value: 'SHOWED_ACTIVITY', label: 'Showed Activity', color: 'bg-surface-3 text-text-secondary' },
    { value: 'NUDGED', label: 'Nudged', color: 'bg-warning-muted text-warning' },
    { value: 'POSTED', label: 'Posted', color: 'bg-success-muted text-success' },
    { value: 'PAID', label: 'Paid', color: 'bg-info-muted text-info' }
  ]
};

export const getCreatorStatusLabel = (status) => {
  if (!status) return 'Unknown';
  const statusOption = CREATOR_STATUS_OPTIONS.find(option => option.value === status);
  if (statusOption) return statusOption.label;
  // Fallback: try case-insensitive match
  if (typeof status === 'string') {
    const match = CREATOR_STATUS_OPTIONS.find(option =>
      option.value.toLowerCase() === status.toLowerCase()
    );
    if (match) return match.label;
  }
  return status;
};

export const getCreatorStatusColor = (status) => {
  // First try exact match
  let statusOption = CREATOR_STATUS_OPTIONS.find(option => option.value === status);

  // If no match found, try case-insensitive match
  if (!statusOption && typeof status === 'string') {
    statusOption = CREATOR_STATUS_OPTIONS.find(option =>
      option.value.toLowerCase() === status.toLowerCase()
    );

    // If still no match, try removing spaces and special characters
    if (!statusOption) {
      const normalizedStatus = status.toLowerCase().replace(/[^a-z0-9]/g, '');
      statusOption = CREATOR_STATUS_OPTIONS.find(option =>
        option.value.toLowerCase().replace(/[^a-z0-9]/g, '') === normalizedStatus
      );
    }
  }

  return statusOption ? statusOption.color : CREATOR_STATUS_OPTIONS[0].color;
};

export const getCampaignStatusColor = (status, phase) => {
  const statusOptions = CAMPAIGN_STATUS_OPTIONS[phase] || [];
  const statusOption = statusOptions.find(option => option.value === status);
  return statusOption ? statusOption.color : statusOptions[0]?.color || 'bg-surface-3 text-text-secondary';
};
